import Swiper, { Navigation, Pagination, Lazy } from 'swiper';

Swiper.use([Navigation, Pagination, Lazy]);

const clientwincarousels = document.querySelectorAll(
	'[data-js=clientwincarousel]'
);

for (let i = clientwincarousels.length - 1; i >= 0; i -= 1) {
	const sliderEl = clientwincarousels[i].querySelector(
		'[data-js=clientwincarousel-carousel]'
	);

	// eslint-disable-next-line no-new
	new Swiper(sliderEl, {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 1,
		spaceBetween: 10,
		loop: true,
	});
}
